import { useState } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { fakeMultiSelectOptions } from "@/__mocks__/multiselect";
import type { MultiSelectTextFieldProps } from "@/ui/composed/pickers/MultiSelectTextField";
import MultiSelectTextField from "@/ui/composed/pickers/MultiSelectTextField";
import { Box } from "@/ui/layout";
import { joinWithCommas } from "@/utils/string.util";

const StoryMeta: Meta<MultiSelectTextFieldProps> = {
  title: "Components/Common/Multi Select Text Field",
  component: MultiSelectTextField,
  argTypes: {
    isDisabled: { control: "boolean" },
    isSingleSelect: { control: "boolean" },
    modalTitle: { control: "text" },
    onValuesChange: { action: "options changed" },
    options: { control: "object" },
  },
  args: {
    isDisabled: false,
    isSingleSelect: false,
    modalTitle: "Select Options",
    options: fakeMultiSelectOptions(10),
  },
  // eslint-disable-next-line no-restricted-syntax -- non-arrow function used here as React FC needed for use of state hook
  render: function Render(args) {
    const { isDisabled, isSingleSelect, modalTitle, options } = args;

    const [value, setValue] = useState<string[]>([]);

    return (
      <Box width="100%">
        <MultiSelectTextField
          defaultSelectedValues={value.map((v) => ({
            displayText: v,
            value: v,
          }))}
          isDisabled={isDisabled}
          isSingleSelect={isSingleSelect}
          modalTitle={modalTitle}
          onValuesChange={(values) =>
            setValue(values.map((v) => v.displayText))
          }
          options={options}
          testID=""
          value={joinWithCommas(value)}
        />
      </Box>
    );
  },
};

type Story = StoryObj<MultiSelectTextFieldProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
